import React from 'react';
import styled from 'styled-components';
import useSettings from './hooks/useSettings';
import { SettingCategory } from './types';
import {
  ContentManagement,
  SettingsToastHelper,
} from '../../components/OrganisationMembers/Settings';
import Footer from '../../components/Common/Footer';
import { SAVE_CHANGES } from '../../utils/constants';
import Loading from '../../components/Loading';

const StyledContainer = styled.div`
  height: 100%;
`;

const StyledBody = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 8px;

  height: calc(100% - 105px); // 105px = footer height
  padding: 24px 48px;

  .separator {
    margin: 12px 0;
  }
`;

const Settings = () => {
  const {
    isLoading,
    settings,
    onUpdate,
    onSaveChanges,
    isViewOnlyRole,
    isFormValid,
  } = useSettings();

  const contentManagementSettings = () =>
    settings.get(SettingCategory.contentManagement) || [];

  return (
    <React.Fragment>
      <StyledContainer>
        <StyledBody>
          {isLoading && <Loading />}
          {!isLoading && (
            <React.Fragment>
              <ContentManagement
                settings={contentManagementSettings()}
                onUpdate={onUpdate}
              />
            </React.Fragment>
          )}
        </StyledBody>

        <Footer
          hideCancelButton
          isSubmitDisabled={isLoading || !isFormValid || isViewOnlyRole}
          submitButtonText={SAVE_CHANGES}
          onSubmit={onSaveChanges}
        />
      </StyledContainer>
      <SettingsToastHelper.ToastComponent />
    </React.Fragment>
  );
};

export default Settings;
